import { ChevronRight, type LucideIcon } from 'lucide-react'

type ProfessionItemProps = {
  /* Default style is shown in the dropdown. Header style is the style shown in the header. */
  style?: 'default' | 'header'
  onClick?: () => void
  Icon?: LucideIcon
  label: string
  subtitle?: string
  isSelected?: boolean
}

const ProfessionItem = ({ onClick, Icon, label, subtitle, style = 'default' }: ProfessionItemProps) => {
  if (style === 'header') {
    return (
      <div className="flex w-full items-center justify-between rounded-lg pr-4">
        <div className="flex items-center gap-3">
          <div className="flex size-[30px] min-w-[30px] items-center justify-center rounded-sm bg-secondary/10">
            {Icon && <Icon className="size-5" />}
          </div>
          <div className="flex flex-col">
            <span className="line-clamp-1 text-[15px] font-semibold">{label}</span>
            {subtitle && <span className="line-clamp-1 text-[12px] text-muted">{subtitle}</span>}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="group/profession-item flex w-full cursor-pointer items-center justify-between rounded-lg"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="flex size-[34px] min-w-[34px] items-center justify-center rounded-[10px] bg-[#F8F7F5] md:size-[55px] md:min-w-[55px]">
          {Icon && <Icon className="size-5 md:size-7" />}
        </div>
        <div className="flex flex-col">
          <span className="line-clamp-1 text-[15px] font-semibold md:text-[16px]">{label}</span>
          {subtitle && <span className="line-clamp-1 text-[12px] text-muted md:text-[13px]">{subtitle}</span>}
        </div>
      </div>
      {/* {isSelected ? (
        <div className="flex size-[25px] min-w-[25px] items-center justify-center rounded-full bg-black">
          <Check className="size-[10px] text-white" />
        </div>
      ) : (
        <div className="flex size-[25px] min-w-[25px] items-center justify-center rounded-full bg-gray-300">
          <Check className="size-[10px] text-gray-500" />
        </div>
      )} */}
      <div className="flex size-[25px] min-w-[25px] items-center justify-center rounded-full">
        <ChevronRight className="size-[21px] text-primary" />
      </div>
    </div>
  )
}

export default ProfessionItem
